import { render, staticRenderFns } from "./CourseModalCreditsDetails.vue?vue&type=template&id=208565e7&scoped=true"
import script from "./CourseModalCreditsDetails.vue?vue&type=script&lang=js"
export * from "./CourseModalCreditsDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseModalCreditsDetails.vue?vue&type=style&index=0&id=208565e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208565e7",
  null
  
)

export default component.exports